import { APP_INITIALIZER, NgModule } from '@angular/core';

import { Observable } from 'rxjs';

import { CurrenciesService } from '@finverity/platform-app/shared/services';

import { getNonceFromMetaTag, getTrustedScriptURL } from '../../utils';

import { CompanyDocumentsService } from './services/company-documents.service';
import { CountriesService } from './services/countries.service';

function initializeUserDocumentsFactory(userDocumentsService: CompanyDocumentsService): () => Observable<any> {
  return () => userDocumentsService.getCompanyDocuments();
}

function initializeCurrencyFactory(currenciesService: CurrenciesService): () => Observable<any> {
  return () => currenciesService.getCurrencies();
}

function initializeCountriesFactory(countriesService: CountriesService): () => Observable<any> {
  return () => countriesService.getCountries();
}

function initializeGoogleMapsApi(): () => Promise<void> {
  return () =>
    new Promise<void>(resolve => {
      const script = document.createElement('script');
      script.defer = true;
      script.src = getTrustedScriptURL(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc&libraries=places&loading=async'
      );

      // Allow app to render in either cases
      script.onload = () => resolve();
      script.onerror = () => resolve();

      const nonce = getNonceFromMetaTag();

      if (nonce) {
        script.setAttribute('nonce', nonce);
      }

      document.head.appendChild(script);
    });
}

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeUserDocumentsFactory,
      deps: [CompanyDocumentsService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCurrencyFactory,
      deps: [CurrenciesService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCountriesFactory,
      deps: [CountriesService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGoogleMapsApi,
      multi: true,
    },
  ],
})
export class SettingsModule {}
